import React from 'react';
import { ArrowDownWideNarrow, Search, X } from 'lucide-react';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const OriginalsToolbar = ({ query, setQuery, sort, setSort, count }) => (
  <div className="originals-toolbar">
    <div className="originals-search">
      <Search size={20} aria-hidden="true" />
      <Input type="search" value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search your game"
        aria-label="Search Originals games" maxLength={120} data-testid="originals-search-input" className="originals-search-input" />
      {query && <button type="button" onClick={() => setQuery('')} className="originals-search-clear" aria-label="Clear search" title="Clear search" data-testid="originals-clear-search"><X size={18} aria-hidden="true" /></button>}
    </div>
    <div className="originals-filter-row">
      <p className="originals-game-count" role="status" aria-live="polite" data-testid="originals-game-count">{count} {count === 1 ? 'game' : 'games'}</p>
      <div className="originals-sort">
        <ArrowDownWideNarrow size={17} aria-hidden="true" />
        <Select value={sort} onValueChange={setSort}>
          <SelectTrigger aria-label="Sort games" data-testid="originals-sort-select"><SelectValue /></SelectTrigger>
          <SelectContent data-testid="originals-sort-menu">
            <SelectItem value="default" data-testid="originals-sort-default">Default order</SelectItem>
            <SelectItem value="az" data-testid="originals-sort-az">Name: A–Z</SelectItem>
            <SelectItem value="za" data-testid="originals-sort-za">Name: Z–A</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  </div>
);